window.History = function () {
    var el = this;
    var items = {};
    var index = 0;
    var MAX_ITEMS = 11;
    
    el.init = function() {
        items[index] = $.extend(true, {}, el.workData);
    };
    
    el.add = function() {
        if (items.hasOwnProperty(index)) {
            index++;
        }
        
        items[index] = $.extend(true, {}, el.workData);
        
        var keys = Object.keys(items);
        if (keys.length > MAX_ITEMS) {
            delete items[keys[0]];
        }
    };
    
    function getPrevious() {
        if (items.hasOwnProperty(index - 1)) {
            index--;
        }
        
        render();
    };
    
    function getNext() {
        if (items.hasOwnProperty(index + 1)) {
            index++;
        }

        render();
    };
    
    function render() {
        el._parent.workData = $.extend(true, {}, items[index]); 
        el.workarea.render();
        el.upImages.reInitUsedImages();
    }
    
    $(document).on('click', '.js-previous-change', getPrevious);
    $(document).on('click', '.js-next-change', getNext);
};